<template>
    <div class="control-panel-container">
	    <ul class="list-unstyled">
            <!-- toolbar for table -->
	        <li v-if="componentName == 'table-component'" class="tasks">
	            <div class="control-item-header no-border-top">
	                <span class="text"><i class="material-icons">settings</i> Selected</span>
	            </div>
	            <div class="control-item-content open">
                    <!-- <button type="button" -->
                    <!--     v-if="content.data" -->
                    <!--     v-on:click="onCreating" -->
                    <!--     :class="['btn', 'btn-block', 'btn-rounded', 'btn-success']" -->
                    <!--     ><i class="material-icons">add</i>Create {{singular(content.type)}} -->
                    <!-- </button> -->
                    <template v-for="(action, idx) in batchActions">
                        <hr v-if="idx > 0">
                        <div v-if="action.name == 'active'" class="control-item-switch text-center mb-4">
                            <label :class="['col-form-label', 'mr-4', 'd-inline', currentSelectedActive ? 'text-secondary' : 'text-default']">Disable</label>
                            <custom-switch-component
                                :value="currentSelectedActive"
                                v-on:input="toggleSelectedActive"
                                ></custom-switch-component>
                            <label :class="['col-form-label', 'ml-4', 'd-inline', currentSelectedActive ? 'text-success' : 'text-secondary']">Enable</label>
                        </div>
                        <button type="button"
                            v-if="action.name == 'delete'"
                            v-on:click="deleteSelected"
                            :disabled="!_.size(selected)"
                            class="btn btn-block btn-md btn-danger btn-rounded">
                            <i class="material-icons">delete</i>
                            Delete Selected
                        </button>
                        <component
                            :key="action.name"
                            :content="content"
                            :selected="selected"
                            :addNotification="addNotification"
                            :updateBatch="updateBatch"
                            :createData="createData"
                            :updateData="updateData"
                            :deleteData="deleteData"
                            :config="action"
                            :is="action.component"
                            ></component>
                    </template>
                </div>
            </li>
	    </ul>
	    <a :class="['control-panel-toggle d-flex align-items-center', open ? 'open' : '']" v-on:click="closePanel">
            <i class="material-icons m-auto">close</i>
	    </a>
	</div>
</template>
<script>
import Vue from 'vue';
import V from 'voca';
import _ from 'lodash';
import CustomSwitchComponent from './form-elements/CustomSwitchComponent';
import { plural, singular } from 'pluralize';

export default {
    data() {
        return {
            open: true,
            currentRevision: '',
            currentSelectedActive: false,
            tempSelectedActive: true,
        }
    },

    props: [
        'content', 'selected', 'user', 'contentErrors', 'timestamp', 'dirty',
        'changeUrl', 'changeQuery', 'changeSection', 'haltFetch',
        'createData', 'updateData', 'deleteData', 'updateBatch',
        'addNotification', 'getContentFormData',
        'componentName', 'componentConfig',
    ],

    components: {
        CustomSwitchComponent,
    },

    watch: {
        timestamp(val) {

        },
        dirty(newVal) {
            console.log(newVal);
        }
    },

    computed: {
        config() {
            return this.componentConfig || {};
        },

        batchActions() {
            return _.get(this.componentConfig, 'batchActions', [])
                .map(item => {
                    if (_.isObject(item)) return item;

                    return {
                        name: item,
                    }
                })
        },

        meta() {
            return this.content.meta || {};
        },

        revisions() {
            let revisions = this.meta.versions || [];
            revisions = [
                { value: '', text: 'draft' },
                ...revisions.map(rev => ({ value: rev.id, text: rev.created_at })),
            ];
            return revisions;
        },

        isCreating() {
            return this.content && this.content.attributes && !this.content.id;
        },

        isEditing() {
            return this.content && this.content.attributes && this.content.id;
        },

        // content status control section
        hasStatus() {
            return _.has(this.content, 'meta.active');
        },

        active() {
            return _.get(this.content, 'meta.active');
        },

        viewable() {
            return _.has(this.content, 'meta.preview');
        },

        publishable() {
            return _.has(this.content, 'meta.published');
        },

        published() {
            return _.get(this.content, 'meta.published');
        },

        canPublish() {
            return this.publishable && !this.published && !this.dirty;
        },
    },

    mounted() {
        console.log('Component mounted.')
        const documentBody = document.getElementsByTagName('body')[0];
        documentBody.classList.add('control-panel');
        documentBody.classList.add('control-panel-compact');
        if (this.open) {
            documentBody.classList.add('open');
        }

    },

    destroyed() {
        const documentBody = document.getElementsByTagName('body')[0];
        documentBody.classList.remove('control-panel');
        documentBody.classList.remove('control-panel-compact');
        documentBody.classList.remove('open');
    },

    methods: {
        togglePanel() {
            const documentBody = document.getElementsByTagName('body')[0];
            documentBody.classList.toggle('open');
            this.open = !this.open;
        },

        closePanel() {
            this.$emit('close');
        },

        changeRevision(id) {
            this.changeQuery({
                rev: id
            });
        },

        submit() {
            const data = this.content.attributes;
            const fieldErrorPairs = _.toPairs(this.contentErrors);
            if (fieldErrorPairs.length > 0) {
                return this.addNotification({
                    type: 'error',
                    message: fieldErrorPairs.map(([field, error]) => `${V.capitalize(field).replace('_', ' ')}: ${error}`),
                })
            }

            if (this.isCreating) {
                this.haltFetch();
                this.createData(data, { setNotification: true, updateRoute: true })
                    .then(() => this.onCreated(this.type, data));
            } else {
                this.updateData(data, { setNotification: true })
                    .then(() => this.onUpdated(this.type, data));
            }
        },

        deleteItem() {
            const status = confirm('Are you sure to delete this content?');
            return status && this.deleteData({ setNotification: true })
                .then(() => this.onDeleted(this.type));
        },

        activate() {
            this.updateData({ active: 1, }, { setNotification: true });
        },

        deactivate() {
            this.updateData({ active: 0, }, { setNotification: true });
        },

        toggleActive(value) {
            if (value == _.get(this.content, 'meta.active')) return;
            this.updateData({ active: value, }, { setNotification: true });
        },

        publish() {
            this.updateData({ publish: 1, }, { setNotification: true });
        },

        deleteSelected() {
            const status = confirm('Are you sure to delete these contents?');

            return status && this.updateBatch([
                ...this.selected.map(itemId => ({ id: itemId, $delete: true }))
			], {
				setNotification: true,
			});
        },

        toggleSelectedActive(value) {
            if (value) {
                this.activateSelected();
            } else {
                this.deactivateSelected();
            }

            this.$nextTick(() => {
                this.currentSelectedActive = !this.currentSelectedActive;
            })
        },

        activateSelected() {
            return this.updateBatch([
                    ...this.selected.map(itemId => ({ id: itemId, $update: { active: 1 } }))
                ], {
                    setNotification: true,
                })
        },

        deactivateSelected() {
            return this.updateBatch([
                    ...this.selected.map(itemId => ({ id: itemId, $update: { active: 0 } }))
                ], {
                    setNotification: true,
                })
        },

        onDeleted() {
            this.$emit('content::deleted', this.content);
        },

        onUpdated() {
            this.currentRevision = '';
            this.changeQuery({
                rev: ''
            });
            this.$emit('content::updated', this.content)
        },

        onCreating() {
            this.$emit('content::creating', {
                type: this.content.schema.instanceType,
                attributes: {},
                meta: {},
                schema: this.content.schema,
            })
        },

        onCreated() {
            this.$emit('content::created', this.content);
        },

        logout(e) {
            e.preventDefault();
            this.helpers('api').logout()
                .finally(() => window.location.href = '/admin/login');
        },

        titleCase(value) {
            return V.titleCase(value);
        },

        singular(type) {
            return singular(type);
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/ControlPanelComponent.vue